var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarcodeScanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.998 21.004h-1a3.001 3.001 0 01-3.002-3.002v-1M17.002 2.996h1a3.001 3.001 0 013.002 3.001v1M2.996 6.998v-1a3.001 3.001 0 013.001-3.002h1M21.004 17.002v1a3.001 3.001 0 01-3.002 3.002h-1M5.997 12V9A3.001 3.001 0 019 5.997H15A3.001 3.001 0 0118.003 9v3.002M18.003 15.001A3.001 3.001 0 0115 18.002H9a3.001 3.001 0 01-3.002-3.001M3.997 12h17.007",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgBarcodeScanner;